export class PictosUtils {

    public static toLabel(pictoName: string): string {
        switch (pictoName) {
          case '2PEHD':
            return 'Matière 2PEHD';
          case '5pp':
            return 'Matière 5PP';
          case '6ps':
            return 'Matière 6PS';
          case 'avec-porte-chromos':
            return 'Avec porte-chromos';
          case 'Brillant':
            return 'Brillant';
          case 'Mat':
            return 'Mat';
          case 'Granité':
            return 'Granité';
          case 'injecte':
            return 'Injecté';
          case 'colorama':
            return 'Colorama';
          case 'drainage':
            return 'Irrigation';
          case 'etoile':
            return 'Étoile'
          case 'NIR':
            return 'NIR';
          case 'nouveaute':
            return 'Nouveauté';
          case 'pcr':
            return 'PCR';
          case 'plaque-eco':
            return 'Plaque ECO';
          case 'plaque-reutilisable':
            return 'Plaque réutilisable';
          case 'plaque-roll-cc':
            return 'Plaque Roll CC';
          case 'prise':
            return 'Fourche';
          case 'tarif-5':
            return 'Tarif 5%';
          case 'thermoforme':
            return 'Thermoformé';
        }
        return pictoName;
      }
}